import { connect } from "react-redux";
import StartNewQuote from "./startNewQuote";

const mapStateToProps = state => ({
  currentStep: state.newQuote.currentStep,
  quoteStarted: state.newQuote.quoteStarted
});

export default connect(mapStateToProps)(StartNewQuote);
